import { makeStyles } from '@material-ui/core/styles';

const useStylesBase = () => makeStyles((theme) => ({
  card: {
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    position: 'relative',
    justifyContent: 'center',
  },
  theCount: {
    color: theme.palette.white.main,
    fontWeight: 'bold',
    fontSize: '60px',
  },
  TheMessage: {
    color: theme.palette.white.main,
  },
  cardactions: {
    'justify-content': 'center',
  },
  cardHeader: {
    backgroundColor: 'transparent',
  },
  headerPaper: {
    height: '47px',
    backgroundColor: 'transparent',
    color: theme.palette.white.main,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 14px',
  },
  cardContent: {
    padding: '0',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 'auto',
    maxWidth: '234px',
    margin: '0 auto',
  },
  cardButton: {
    marginTop: '26px',
    color: theme.palette.white.main,
    borderColor: theme.palette.white.main,
    fontWeight: 'semi-bold',
  },
}));
export default useStylesBase;
